import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIClient } from "../../helpers/api_helper";
import * as url from "../../helpers/url_helper";

const api = new APIClient();

/**
 * Submit support contact form
 * Creates a support ticket and sends notification emails
 */
export const submitSupportContact = createAsyncThunk(
  "help/submitSupportContact",
  async (contactData, { rejectWithValue }) => {
    try {
      if (!contactData || Object.keys(contactData).length === 0) {
        return rejectWithValue("No contact data provided");
      }

      // Validate required fields
      const requiredFields = ["name", "email", "mobile", "issueDescription"];
      const missingFields = requiredFields.filter((field) => !contactData[field]);

      if (missingFields.length > 0) {
        return rejectWithValue(`Missing required fields: ${missingFields.join(", ")}`);
      }

      const response = await api.create(url.SUBMIT_CONTACT_FORM, contactData);

      if (!response || !response.message) {
        return rejectWithValue("Invalid response from server");
      }

      return response;
    } catch (error) {
      const errorMessage = typeof error === "string" ? error : error?.message || "Failed to submit support request";
      return rejectWithValue(errorMessage);
    }
  }
);

const initialState = {
  loading: false,
  error: null,
  successMessage: null,
  ticketId: null,
};

const helpSlice = createSlice({
  name: "help",
  initialState,
  reducers: {
    /**
     * Reset error and success messages
     */
    resetHelpState: (state) => {
      state.successMessage = null;
      state.error = null;
      state.ticketId = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(submitSupportContact.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.successMessage = null;
        state.ticketId = null;
      })
      .addCase(submitSupportContact.fulfilled, (state, action) => {
        state.loading = false;
        state.successMessage =
          action.payload.message || "Your message has been sent successfully. We'll get back to you soon!";
        state.ticketId = action.payload.ticketId || null;
        state.error = null;
      })
      .addCase(submitSupportContact.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to submit support request. Please try again.";
        state.successMessage = null;
        state.ticketId = null;
      });
  },
});

export const { resetHelpState } = helpSlice.actions;
export default helpSlice.reducer;
